export default "__VITE_ASSET__B6iijCny__"